
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormContainer } from "../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { Msg } from "./Types.js";
import { defaultArgWith, defaultArg, map as map_1, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { Select } from "../../Components/Select.js";
import { singleton as singleton_1, append as append_1, ofArray, tryFind, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { NewReceiverCustomProperties } from "../../Widgets/CustomProperties.js";
import { PropertyConfigurationVisibility } from "../../Shared/PropertyConfiguration.js";
import { Table_UserVisibleTable } from "../UserSelect.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function VehicleForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("general.name"),
            OnChange: (name) => {
                props.Dispatch(new Msg(0, [name]));
            },
            TestId: "vehicle-form-name-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Vehicle.Name,
        })), delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("vehicle.numberplate"),
            OnChange: (numberPlate) => {
                props.Dispatch(new Msg(1, [numberPlate]));
            },
            TestId: "vehicle-form-numberplate-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "numberplate")),
            Value: props.Vehicle.NumberPlate,
        })), delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("vehicle.manufacturer"),
            OnChange: (manufacturer) => {
                props.Dispatch(new Msg(2, [manufacturer]));
            },
            TestId: "vehicle-form-manufacturer-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "manufacturer")),
            Value: props.Vehicle.Manufacturer,
        })), delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("vehicle.model"),
            OnChange: (model) => {
                props.Dispatch(new Msg(4, [model]));
            },
            TestId: "vehicle-form-model-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "model")),
            Value: props.Vehicle.Model,
        })), delay(() => {
            let Label_4, Options, Value_4, matchValue, locationId;
            return append(singleton(createElement(Select, (Label_4 = t("general.location"), (Options = map((location) => ({
                label: location.Name,
                value: location,
            }), props.Locations), (Value_4 = ((matchValue = props.Vehicle.LocationId, (matchValue == null) ? undefined : ((locationId = matchValue, map_1((location_3) => ({
                label: location_3.Name,
                value: location_3,
            }), tryFind((location_2) => equals(location_2.Id, locationId), props.Locations)))))), {
                ComponentState: "enabled",
                IsClearable: true,
                Label: unwrap(Label_4),
                NoOptionsMessage: "select.location_no_options",
                OnChange: (location_1) => {
                    props.Dispatch(new Msg(6, [map_1((_arg) => _arg.value.Id, location_1)]));
                },
                Options: Options,
                PlaceholderKey: "select.location_placeholder",
                TestId: "vehicle-form-location",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "location")),
                Value: unwrap(Value_4),
            }))))), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
                BusinessUnits: props.BusinessUnits,
                FormState: props.FormState,
                OnChange: (value) => {
                    props.Dispatch(new Msg(7, [value]));
                },
                SelectedBusinessUnitId: unwrap(props.Vehicle.BusinessUnitId),
            })) : empty()) : empty(), delay(() => {
                let Label_5, Value_5;
                return append(isFeatureEnabled(new Feature(15, [])) ? singleton(createElement(Input, (Label_5 = t("general.email"), (Value_5 = defaultArg(props.Vehicle.Email, ""), {
                    ComponentState: componentState,
                    Label: unwrap(Label_5),
                    OnChange: (arg) => {
                        props.Dispatch(new Msg(3, [arg]));
                    },
                    TestId: "vehicle-form-email-input",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                    Value: Value_5,
                })))) : empty(), delay(() => append(props.IsCustomPropertiesEnabled ? singleton(createElement(NewReceiverCustomProperties, {
                    Currency: props.CustomerConfiguration.Currency,
                    CustomProperties: props.Vehicle.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperty: (arg_1) => {
                        props.Dispatch(new Msg(5, [arg_1]));
                    },
                    PropertyConfigurationType: new PropertyConfigurationVisibility(9, []),
                    PropertyConfigurations: props.PropertyConfigurations,
                })) : empty(), delay(() => singleton(createElement(Table_UserVisibleTable, {
                    CustomerConfiguration: props.CustomerConfiguration,
                    IsOpen: props.VisibleUserModalIsOpen,
                    OnClose: () => {
                        props.Dispatch(new Msg(10, []));
                    },
                    OnDelete: props.OnDeleteVisibleUserIds,
                    OnSave: props.OnSaveVisibleUserIds,
                    PropertyConfigurations: props.PropertyConfigurations,
                    SetIsOpen: () => {
                        props.Dispatch(new Msg(10, []));
                    },
                    Users: props.Users,
                    VisibleForUserIds: props.Vehicle.VisibleForUserIds,
                }))))));
            }))));
        })))))))))),
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewVehicleView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.IsCustomPropertiesEnabled;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.Users;
    const matchValue_4 = state_1.Locations;
    const matchValue_5 = state_1.AccountSettings;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, locations, propertyConfigurations, users, vehicle;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_5.fields[0];
        businessUnits = matchValue_6.fields[0];
        isCustomPropertiesEnabled = matchValue_1.fields[0];
        locations = matchValue_4.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        users = matchValue_3.fields[0];
        vehicle = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(VehicleForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("vehicle.create_new_vehicle"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["receivers", "vehicles" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                OnDeleteVisibleUserIds: (userIds_1) => {
                    dispatch(new Msg(12, [userIds_1]));
                },
                OnSave: () => {
                    dispatch(new Msg(8, []));
                },
                OnSaveVisibleUserIds: (userIds) => {
                    dispatch(new Msg(11, [userIds]));
                },
                PropertyConfigurations: propertyConfigurations,
                Users: users,
                Vehicle: vehicle,
                VisibleUserModalIsOpen: state_1.VisibleUserModalIsOpen,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function VehicleEditView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.VehicleId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.IsCustomPropertiesEnabled;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.Users;
    const matchValue_4 = state_1.Locations;
    const matchValue_5 = state_1.AccountSettings;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, locations, propertyConfigurations, users, vehicle;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_5.fields[0];
        businessUnits = matchValue_6.fields[0];
        isCustomPropertiesEnabled = matchValue_1.fields[0];
        locations = matchValue_4.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        users = matchValue_3.fields[0];
        vehicle = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(VehicleForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("vehicle.edit_vehicle"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString = getQueryParams(undefined);
                    defaultArgWith(map_1((tupledArg) => {
                        RouterModule_nav(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton_1(RouterModule_encodeQueryString(queryString)), 1, 1);
                    });
                },
                OnDeleteVisibleUserIds: (userIds_1) => {
                    dispatch(new Msg(12, [userIds_1]));
                },
                OnSave: () => {
                    dispatch(new Msg(9, []));
                },
                OnSaveVisibleUserIds: (userIds) => {
                    dispatch(new Msg(11, [userIds]));
                },
                PropertyConfigurations: propertyConfigurations,
                Users: users,
                Vehicle: vehicle,
                VisibleUserModalIsOpen: state_1.VisibleUserModalIsOpen,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

